import { createFeatureSelector } from '../../create-feature-selector';
import { LAMINATE_CALCULATOR_IDS } from 'common/constants';
import { createSelector } from 'reselect';
import { ProjectConfigurationsKeyNames } from '../types';

const featureRootSelector = createFeatureSelector('configurations');

export const getLaminate = createSelector(featureRootSelector, (v) => v.laminate);

export const getLaminateConfiguration = createSelector(getLaminate, (v) => v.configuration ?? []);

export const getLaminateConfigurationArea = createSelector(getLaminateConfiguration, (conf) => {
  const area = conf.find(({ key }) => key === ProjectConfigurationsKeyNames.area)?.value;
  return area ? Number(area) : undefined;
});

export const getLaminatConfigurationPriceCoefficient = createSelector(getLaminateConfiguration, (conf) => {
  const priceCoefficient = conf.find(
    ({ key }) => key === ProjectConfigurationsKeyNames.priceCoefficient,
  )?.value;
  return priceCoefficient ? Number(priceCoefficient) : undefined;
});

export const isLaminateConfigurationCalculator = createSelector(getLaminateConfiguration, (conf) => {
  const calculatorId = conf.find(({ key }) => key === ProjectConfigurationsKeyNames.calculatorId)?.value;
  return calculatorId ? LAMINATE_CALCULATOR_IDS.includes(calculatorId) : false;
});

export const getLaminateConfigurationLoading = createSelector(getLaminate, (v) => v.loading);
